import {
    doc,
    getDoc,
    setDoc,
    updateDoc,
    deleteDoc,
    collection,
    getDocs,
    query,
    orderBy,
    serverTimestamp,
} from "firebase/firestore";

import { auth, db } from "../firebase";

/**
 * Creates or updates a journal entry.
 * One document per activity.
 */
export async function saveJournalEntry(
    activityId,
    data = {}
) {

    const user = auth.currentUser;

    if (!user) return;

    const ref = doc(
        db,
        "users",
        user.uid,
        "journal",
        activityId
    );

    const snapshot = await getDoc(ref);

    if (snapshot.exists()) {

        await setDoc(

            ref,

            {
                lastUpdated: serverTimestamp(),

                ...data,

            },

            {
                merge: true,
            }

        );

    } else {

        await setDoc(

            ref,

            {
                completedAt: serverTimestamp(),

                lastUpdated: serverTimestamp(),

                favourite: false,

                userNotes: "",

                ...data,

            }

        );

    }

}
/**
 * Load one journal entry
 */

export async function getJournalEntry(activityId) {

    const user = auth.currentUser;

    if (!user) return null;

    const ref = doc(
        db,
        "users",
        user.uid,
        "journal",
        activityId
    );

    const snap = await getDoc(ref);

    if (!snap.exists()) return null;

    return snap.data();

}

/**
 * Load every journal entry
 */
export async function getAllJournalEntries() {

    const user = auth.currentUser;

    if (!user) return [];

    const snapshot = await getDocs(

        query(

            collection(
                db,
                "users",
                user.uid,
                "journal"
            ),

            orderBy(
                "lastUpdated",
                "desc"
            )

        )

    );

    return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }));

}

/**
 * Save the user's notes
 */

export async function updateJournalNotes(
    activityId,
    userNotes
) {

    const user = auth.currentUser;

    if (!user) return;

    await updateDoc(

        doc(
            db,
            "users",
            user.uid,
            "journal",
            activityId
        ),

        {
            userNotes,
            lastUpdated: serverTimestamp()
        }

    );

}

/**
 * Mark or unmark a favourite
 */
export async function setFavourite(
    activityId,
    favourite
) {

    const user = auth.currentUser;

    if (!user) return;

    await updateDoc(

        doc(
            db,
            "users",
            user.uid,
            "journal",
            activityId
        ),

        {
            favourite,
            lastUpdated: serverTimestamp()
        }

    );

}
/**
 * Delete a journal entry
 */
export async function deleteJournalEntry(
    activityId
) {

    const user = auth.currentUser;

    if (!user) return;

    await deleteDoc(

        doc(
            db,
            "users",
            user.uid,
            "journal",
            activityId
        )

    );

}